"use client";

import { useEffect, useState } from "react";

import { elapsedMsBetween, formatElapsedMs } from "./format-elapsed";

/** Live status: current tool · elapsed — or Completed in … */
export function InsightsLiveStatus({
  running,
  startedAt,
  durationMs,
  currentTool,
}: {
  running: boolean;
  startedAt?: string | null;
  durationMs?: number | null;
  /** Pre-formatted tool label (may include arg summary). */
  currentTool?: string | null;
}) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!running || !startedAt) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [running, startedAt]);

  if (running && startedAt) {
    const start = Date.parse(startedAt);
    const ms = Number.isFinite(start) ? Math.max(0, now - start) : 0;
    const parts: string[] = [];
    // Task title lives in the chat panel + Tasks rail — footer is tool-only.
    if (currentTool?.trim()) {
      const tool = currentTool.length > 64 ? `${currentTool.slice(0, 61)}…` : currentTool;
      parts.push(tool);
    } else {
      parts.push("Working");
    }
    parts.push(formatElapsedMs(ms));
    return (
      <p className="flex items-center gap-1.5 text-[12px] text-muted-foreground tabular-nums">
        <span className="size-1.5 shrink-0 animate-pulse rounded-full bg-primary/70" aria-hidden />
        <span>{parts.join(" · ")}</span>
      </p>
    );
  }

  if (durationMs != null && durationMs >= 0) {
    return (
      <p className="text-[12px] text-muted-foreground tabular-nums">
        Completed in {formatElapsedMs(durationMs)}
      </p>
    );
  }

  if (startedAt) {
    const ms = elapsedMsBetween(startedAt);
    if (ms != null) {
      return (
        <p className="text-[12px] text-muted-foreground tabular-nums">
          Completed in {formatElapsedMs(ms)}
        </p>
      );
    }
  }

  return null;
}
